package com.karawek.core.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * Semantic wrapper for grouped content.
 *
 * Visually identical to CoreSurface for now.
 * Exists to encode intent and allow future evolution.
 */
@Composable
fun CoreCard(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    CoreSurface(
        modifier = modifier,
        content = content,
    )
}
